import { useParams } from "react-router-dom";
import "./Product.css"
import  {useState } from "react";
import movableAP from "../../../slike/mA.png";
import Al from "../../../slike/al3.png";
import alJoint from "../../../slike/Aljoint.png";
import rollerTrack from "../../../slike/rollertrack.jpg";
import squareP from "../../../slike/Untitled-2.png";
import fElements from "../../../slike/Untitled-3.png";
import cElements from "../../../slike/Untitled-4.png";
import Paccesory from "../../../slike/Untitled-5.png";
import Fe from "../../../slike/floorE.png";
import OtherAcc from "../../../slike/otherAcc.png";
import PlasticCap from "../../../slike/19CAP-1.png";
import tube from "../../../slike/tube.png";
import metalJoint from "../../../slike/metalJoint.png";
import rT from "../../../slike/RT.png";
import rtJoint from "../../../slike/rollerTrackJoint.jpg";
import Caster from "../../../slike/casterWheel.jpg";
import adjust from "../../../slike/adjust.jpg";
import hs1 from "../../../slike/HS1.jpg";
import hs2 from "../../../slike/HS2.png";
import PE from "../../../slike/square6.png";
import hs3 from "../../../slike/heavy7.png";
const Product = () => {
    const params = useParams();
    const name = params.name;
    const [boja,setBoja] = useState("lightgray");
    const [bojaDva,setBojaDva] = useState();
    const [display,setDisplay] = useState("none");
    const [display2,setDisplay2] = useState("block");
    const prvouSivo=()=>{
        setBoja("lightgray");
        setBojaDva("white");
        setDisplay("none")
        setDisplay2("block")
    }  
    const drugoSivo=()=>{
        setBoja("white");
        setBojaDva("lightgray");
        setDisplay("flex")
        setDisplay2("none");
    }
    const tekstovi = [
        {name:"karakuri systems",text:"Our company offers a wide selection of Karakuri systems for industrial automation. We specialize in mechanical solutions that increase efficiency and reduce costs, without the use of electricity. We cooperate with renowned manufacturers, but we also offer more economical options, adapted to your needs."},
        {name:"square profiles",text:"We offer a wide range of square profiles designed for robust and reliable industrial applications. Our profiles are manufactured from high-quality materials, ensuring durability and precision. Whether for custom structures, conveyors, or automated systems, square profiles provide the flexibility and strength you need for your projects."},
        {name:"lean pipe",text:"Our lean pipe systems are the perfect solution for creating dynamic and cost-effective modular structures. Lightweight, versatile, and easy to assemble, they are ideal for lean manufacturing environments. From workstations to storage solutions, lean pipes enable quick adaptation to changing production needs."},
        {name:"Heavy square tube system",text:"The Heavy Square Tube System is engineered for heavy-duty applications requiring maximum strength and stability. Perfect for industrial use, these systems are designed to withstand high loads and demanding environments. Their compatibility with various accessories makes them a versatile choice for complex constructions."}
    ]
    const Karakuriproducts=[
        {slika:Al ,naslov:"Aluminum Tube",link:"/"},
        {slika:alJoint,naslov:"Aluminum Joint",link:"/"},
        {slika:rollerTrack,naslov:"Aluminum Roller Track",link:"/"},
        {slika:movableAP,naslov:"Movable Accessory",link:"/"},
        {slika:OtherAcc,naslov:"Other Accessory",link:"/"},
        {slika:PlasticCap,naslov:"Plastic Cap",link:"/"},
      ]
      const Squareproducts=[
        {slika:squareP ,naslov:"Aluminum Profile",link:"/"},
        {slika:fElements,naslov:"Fastening Elements",link:"/"},
        {slika:cElements,naslov:"Connecting Elements",link:"/"},
        {slika:Paccesory,naslov:"Profile Accessory",link:"/"},
        {slika:Fe,naslov:"Floor Elements",link:"/"},
        {slika:PE,naslov:"Panel Installation Elements",link:"/"}
      ]
      const LeanTube=[
        {slika:tube ,naslov:"Tube",link:"/"},
        {slika:metalJoint,naslov:"Metal Joint",link:"/"},
        {slika:rT,naslov:"Roller Track",link:"/"},
        {slika:rtJoint,naslov:"Roller Track Joint",link:"/"},
        {slika:Caster,naslov:"Caster Wheel",link:"/"},
        {slika:adjust,naslov:"Floor Element",link:"/"},
        {slika:OtherAcc,naslov:"Other Accessory",link:"/"},
      ]
      const HeavySquare = [
        {slika:hs1,naslov:"Square Tube-4545 System",link:"/"},
        {slika:hs2,naslov:"Square Tube-4040 System",link:"/"},
        {slika:hs3,naslov:"Square Perforated Pipe",link:"/"},
      ]
      const handleDownload = (name) => {
        const pdfUrl = "/"+name+".pdf";
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.download = name+".pdf"; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
      
    return ( 
        <div className="productPage">
            <div className="naslovnaProducts">
                <div className="naslovnaMenu">
                    <ul>
                        <li><p>Home page</p></li>
                        <li><p>{'>'}</p></li>
                        <li><p>{name.toLowerCase()}</p></li>
                    </ul>
                    <div className="menuH">
                        <p>{name}</p>
                    </div>
                    <div className="naslovnaH">
                        <div className="informacije">
                                <p style={{"backgroundColor":boja}} onClick={prvouSivo}>GENERAL INFORMATION</p>
                                <p style={{"backgroundColor":bojaDva}} onClick={drugoSivo}>MORE INFORMATION</p>
                        </div>
                        <div className="opsteInformacije" style={{"display":display2}}>
                            {name.toLowerCase()==="karakuri system"?<p>{tekstovi[0].text}</p>:<></>}
                            {name.toLowerCase()==="lean tube system"?<p>{tekstovi[2].text}</p>:<></>}
                            {name.toLowerCase()==="square profiles"?<p>{tekstovi[1].text}</p>:<></>}
                            {name.toLowerCase()==="heavy square tube system"?<p>{tekstovi[3].text}</p>:<></>}
                            </div>
                            <div className="catalogD" style={{"display":display}}>
                                <p>For more detailed information about {name.toLocaleLowerCase()} please contact us via:</p>
                                <p>email: info@modular-parts-system.rs </p>
                                <p>number: 00381 230 590 590</p>
                                <p>or you can download our catalog below:</p>
                                <button  onClick={()=>{handleDownload(name.toLocaleLowerCase())}}>DOWNLOAD CATALOGUE</button>
                            </div>
                    </div>
                </div>
            </div>
            <div className="productsMenu">
            <div className='sP'>
        {name.toLowerCase()==="karakuri system"?Karakuriproducts.map((item,index)=>(
            <div className='okvirP'>
              <div className='productBoxP'>
                <img src={item.slika} className='slikaP' alt='slika'/>
              </div>
              <p>{item.naslov}</p>
          </div>
          )):<></>}
            {name.toLowerCase()==="square profiles"?Squareproducts.map((item,index)=>(
            <div className='okvirP'>
              <div className='productBoxP'>
                <img src={item.slika} className='slikaP' alt='slika'/>
              </div>
              <p>{item.naslov}</p>
          </div>
          )):<></>}
            {name.toLowerCase()==="lean tube system"?LeanTube.map((item,index)=>(
            <div className='okvirP'>
              <div className='productBoxP'>
                <img src={item.slika} className='slikaP' alt='slika'/>
              </div>
              <p>{item.naslov}</p>
          </div>
          )):<></>}
          {name.toLowerCase()==="heavy square tube system"?HeavySquare.map((item,index)=>(
            <div className='okvirP'>
              <div className='productBoxP'>
                <img src={item.slika} className='slikaP' alt='slika'/>
              </div>
              <p>{item.naslov}</p>
          </div>
          )):<></>}
      </div>
            </div>
        </div>
     );
}
 
export default Product;